import { render, staticRenderFns } from "./iconFlag.vue?vue&type=template&id=ac1bb6a0&scoped=true&"
import script from "./iconFlag.vue?vue&type=script&lang=js&"
export * from "./iconFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1bb6a0",
  null
  
)

export default component.exports